import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { loadOrUpdateEqualWeb } from './equalweb';
import { useAuthStore } from '../store/AuthContext';
import { HostProvider } from '../utils/HostProvider';

// eslint-disable-next-line import/prefer-default-export
export function useEqualWeb(enabled: boolean) {
  const { i18n } = useTranslation();
  const dataUser = useAuthStore();

  const flagAccesibilidad = dataUser?.user?.flagAccesibilidad;

  useEffect(() => {
    if (!enabled) return;
    if (flagAccesibilidad === undefined) return;
    console.log(`flagAccesibilidad=${flagAccesibilidad}`);

    let sitekey = 'efd303dbd4a6a6a74ddf62bfd0771b60';
    if (HostProvider.isEroski()) {
      sitekey = 'd550de7b57aeb2e6903f68ad4ac1c2e7';
    }

    loadOrUpdateEqualWeb({
      hideBtn: !flagAccesibilidad,
      position: 'right',
      lang: i18n.language,
      sitekey,
    });
  }, [enabled, i18n.language, flagAccesibilidad]);
}
